'use strict';

import Toast from 'bootstrap/js/dist/toast';

export class VToast {
	constructor(opts = {}) {
		this.toastInstance = '';
		this.toastId = 'vToast';

		this.opts = {
			...{
				title: '',
				text: '',
				bgCls: 'bg-primary',
				closeCls: ''
			},
			...opts
		};

		return this;
	}

	fire() {
		this._buildTemplate();

		let toaster = document.getElementById(this.toastId).querySelector('.toast');

		this.toastInstance = new Toast(toaster, {
			autohide: true, 
			delay: 7000
		});

		this.toastInstance.show();
	}

	_buildTemplate() {
		this._removePrevModal();

		let toastContainer = document.createElement('div');
		
		toastContainer.id = this.toastId;
		toastContainer.setAttribute('class', 'position-fixed p-3 border-0 bottom-0 end-0');
		toastContainer.style.zIndex = 1100;
		toastContainer.innerHTML = this._template();

		document.body.appendChild(toastContainer);

		this._bindEvents();
	}

	_removePrevModal() {
		let toastContainer = document.getElementById(this.toastId);

		if (typeof toastContainer !== 'undefined' && toastContainer !== null) {
			toastContainer.parentNode.removeChild(toastContainer);
		}
	}

	_template() {
		const { opts } = this;

		let html = 
		  `<div class="toast align-items-center text-white ${opts.bgCls} p-3" role="alert" aria-live="assertive" aria-atomic="true">`;

		if (opts.title !== '') {
		
		    html += 
			  `<div class="d-flex">
				 <div class="toast-body"><strong>${opts.title}</strong> ${opts.text}</div>
				 <button type="button" class="btn-close ${opts.closeCls} me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
			   </div>`;
		
		} else {

			html += 
			  `<div class="d-flex">
				 <div class="toast-body">${opts.text}</div>
				 <button type="button" class="btn-close ${opts.closeCls} me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
			   </div>`;
		}

		html += 
		  `</div>`;

		html = html.replace(/(\r\n|\n|\r)/gm, '');

		return html;
	} 

	_bindEvents() {
		const self = this;

		document.getElementById(this.toastId).querySelector('.toast').addEventListener('hidden.bs.toast', (e) => {
			self._removePrevModal();
		});
	}
}